import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var MarketingFilled = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M15.8333 2.5L15 4.16667L9.16667 6.66667V13.3333L15 15.8333L15.8333 17.5H17.5V11.4404C17.7529 11.2944 17.9631 11.0845 18.1093 10.8317C18.2556 10.5789 18.3328 10.2921 18.3333 10C18.3331 9.70766 18.256 9.42053 18.1097 9.16741C17.9634 8.9143 17.7532 8.70411 17.5 8.55794V2.5H15.8333ZM4.16667 6.66667C3.25 6.66667 2.5 7.41667 2.5 8.33333V11.6667C2.5 12.5833 3.25 13.3333 4.16667 13.3333H5.83333V17.5H7.5V11.6667V6.66667H4.16667Z",
    fill: fill
  }));
};
export { MarketingFilled as default };
//# sourceMappingURL=MarketingFilled.js.map
